import React from 'react';
import { TooltipKeys } from '../../tooltips/TooltipKeys';
import UIVoice from '../subcomponents/UIVoice';
import UITextDescription from '../subcomponents/UITextDescription';
import UIHeaders from '../subcomponents/UIHeaders';
import UINextStep from '../subcomponents/UINextStep';
import UIPreviousStep from '../subcomponents/UIPreviousStep';
import UIInsets from '../subcomponents/UIInsets';
import UIInsetsProps from '../subcomponents/UIInsetsProps';
import subComponentTypes from '../subcomponents/types';
import UIEditorComponentRenderer from '../UIEditorComponentRenderer';

export default function TContent(props)
{
	function getRawProperties()
	{
		return {
			[subComponentTypes.INSETS]:{ ...UIInsetsProps({ ...props }) },
			[subComponentTypes.HEADERS]:{ ...UIHeaders({ ...props, size:4, anchor:'bottom', align:'left' }) },
			[subComponentTypes.TEXT_DESCRIPTION]:{ ...UITextDescription({ ...props }) },
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.PREVIOUS_STEP]:{ ...UIPreviousStep({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		}
	}

	if(props.getProperties)
	{
		return getRawProperties();
	}

	function generateInsetsData(insetsProperties)
	{
		// console.log(insetsProperties);
		const subcomponent = 'Insets';

		let generatedInsets = [];
		let insetCounter = 1;
		while(insetsProperties[`inset ${insetCounter} title`])
		{
			generatedInsets.push({
				type: 'group',
				key: `inset ${insetCounter} group`,
				collapsed: true,
				title: `Inset ${insetCounter}`,
				titleAddon: {
					key: `inset ${insetCounter} title`,
					subcomponent: subcomponent
				},
				subcomponent: null,
				decorator: {
					...insetsProperties[`inset ${insetCounter} type`],
					key: `inset ${insetCounter} type`,
					type: 'toggle-icon',
					subcomponent: subcomponent,
					falseValue: 'invisible',
					trueValue: 'image',
					title: '',
				},
				children: [
					{
						...insetsProperties[`inset ${insetCounter} type`],
						key: `inset ${insetCounter} type`,
						subcomponent: subcomponent,
						title: "Type",
					},
					{
						...insetsProperties[`inset ${insetCounter} height`],
						key: `inset ${insetCounter} height`,
						subcomponent: subcomponent,
						title: "Height",
					},
					{
						...insetsProperties[`inset ${insetCounter} anchor`],
						key: `inset ${insetCounter} anchor`,
						subcomponent: subcomponent,
						title: "Anchor",
					}, //here the shitshow begins
					{
						...insetsProperties[`inset ${insetCounter} image`],
						key: `inset ${insetCounter} image`,
						subcomponent: subcomponent,
						title: "Image",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['image', 'step', 'video', 'audio', 'url'],
					},
					{
						...insetsProperties[`inset ${insetCounter} audio`],
						key: `inset ${insetCounter} audio`,
						subcomponent: subcomponent,
						title: "Audio",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['audio'],
					},
					{
						...insetsProperties[`inset ${insetCounter} camera`],
						key: `inset ${insetCounter} camera`,
						subcomponent: subcomponent,
						title: "Camera",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['camera'],
					},
					{
						...insetsProperties[`inset ${insetCounter} title`],
						key: `inset ${insetCounter} title`,
						subcomponent: subcomponent,
						title: "Title",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['camera'],
					},
					{
						...insetsProperties[`inset ${insetCounter} step`],
						key: `inset ${insetCounter} step`,
						subcomponent: subcomponent,
						title: "Target",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['step'],
					},
					{
						...insetsProperties[`inset ${insetCounter} url`],
						key: `inset ${insetCounter} url`,
						subcomponent: subcomponent,
						title: "URL",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['url'],
					},
					{
						...insetsProperties[`inset ${insetCounter} video`],
						key: `inset ${insetCounter} video`,
						subcomponent: subcomponent,
						title: "Video",
						dependingOnProperty: { key: `inset ${insetCounter} type`, subcomponent: subcomponent },
						dependingOnValues: ['video'],
					},
				]
			})
			insetCounter++;
		}
 
		return {
			type: 'group',
			key: 'insets group',
			title: 'Insets',
			subcomponent: null,
			children: generatedInsets
		};
	}

	function repackProperties()
	{
		let rawProperties = getRawProperties();
		// console.log(rawProperties);
		let flatProperties = [
			generateInsetsData(rawProperties.Insets),
			{
				type: 'group',
				key: 'headers group',
				title: rawProperties.Headers.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.Headers.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.Headers.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.Headers.props.properties['anchor'],
						key: 'anchor',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Anchor',
					},
					{
						...rawProperties.Headers.props.properties['alignment'],
						key: 'alignment',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Alignment',
					},
					{
						...rawProperties.Headers.props.properties['header spacing'],
						key: 'header spacing',
						subcomponent: rawProperties.Headers.props.subcomponent,
						title: 'Spacing',
					},
				].concat((()=>
				{
					let generatedHeaders = [];
					let headerCounter = 1;
					while(rawProperties.Headers.props.properties[`header ${headerCounter} text`])
					{
						generatedHeaders.push({
							type: 'group',
							key: `header ${headerCounter} group`,
							collapsed: true,
							title: `Header ${headerCounter}`,
							titleAddon: {
								key: `header ${headerCounter} text`,
								subcomponent: rawProperties.Headers.props.subcomponent
							},
							subcomponent: null,
							decorator: {
								...rawProperties.Headers.props.properties[`header ${headerCounter} visible`],
								key: `header ${headerCounter} visible`,
								type: 'toggle-icon',
								subcomponent: rawProperties.Headers.props.subcomponent,
								title: '',
							},
							children: [
								{
									...rawProperties.Headers.props.properties[`header ${headerCounter} text`],
									key: `header ${headerCounter} text`,
									subcomponent: rawProperties.Headers.props.subcomponent,
									title: "",
								},
								{
									type: 'color-alpha',
									title: "Text",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} text color`],
										key: `header ${headerCounter} text color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} text alpha`],
										key: `header ${headerCounter} text alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Background",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} background color`],
										key: `header ${headerCounter} background color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} background alpha`],
										key: `header ${headerCounter} background alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									type: 'color-alpha',
									title: "Stroke",
									color: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} shadow color`],
										key: `header ${headerCounter} shadow color`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
									alpha: {
										...rawProperties.Headers.props.properties[`header ${headerCounter} shadow alpha`],
										key: `header ${headerCounter} shadow alpha`,
										subcomponent: rawProperties.Headers.props.subcomponent,
									},
								},
								{
									...rawProperties.Headers.props.properties[`header ${headerCounter} link`],
									key: `header ${headerCounter} link`,
									subcomponent: rawProperties.Headers.props.subcomponent,
									title: "Target",
								},
							]
						})
						headerCounter++;
					}
					return generatedHeaders;
				})())
			},
			{
				type: 'group',
				key: 'text description group',
				title: rawProperties.TextDescription.props.title,
				subcomponent: null,
				decorator: {
					...rawProperties.TextDescription.props.properties['visible'],
					key: 'visible',
					type: 'toggle-icon',
					subcomponent: rawProperties.TextDescription.props.subcomponent,
					title: '',
				},
				children: [
					{
						...rawProperties.TextDescription.props.properties.description,
						key: 'description',
						subcomponent: rawProperties.TextDescription.props.subcomponent,
						title: "",
					},
					{
						type: 'color-alpha',
						title: "Text",
						color: {
							...rawProperties.TextDescription.props.properties['text color'],
							key: 'text color',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
						alpha: {
							...rawProperties.TextDescription.props.properties['text alpha'],
							key: 'text alpha',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Background",
						color: {
							...rawProperties.TextDescription.props.properties['background color'],
							key: 'background color',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
						alpha: {
							...rawProperties.TextDescription.props.properties['background alpha'],
							key: 'background alpha',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
					},
					{
						type: 'color-alpha',
						title: "Stroke",
						color: {
							...rawProperties.TextDescription.props.properties['shadow color'],
							key: 'shadow color',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
						alpha: {
							...rawProperties.TextDescription.props.properties['shadow alpha'],
							key: 'shadow alpha',
							subcomponent: rawProperties.TextDescription.props.subcomponent,
						},
					},
					{
						...rawProperties.TextDescription.props.properties['text alignment'],
						key: 'text alignment',
						type: 'align-text',
						subcomponent: rawProperties.TextDescription.props.subcomponent,
						title: "Alignment",
					},
					{
						...rawProperties.TextDescription.props.properties['font size'],
						key: 'font size',
						subcomponent: rawProperties.TextDescription.props.subcomponent,
						title: "Text Size",
					},
					{
						...rawProperties.TextDescription.props.properties['preset'],
						key: 'preset',
						subcomponent: rawProperties.TextDescription.props.subcomponent,
						title: "Preset",
					},
				]
			},
			{
				...rawProperties.NextStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.NextStep.props.subcomponent,
				title: rawProperties.NextStep.props.title,
			},
			{
				...rawProperties.PreviousStep.props.properties.visible,
				key: 'visible',
				subcomponent: rawProperties.PreviousStep.props.subcomponent,
				title: rawProperties.PreviousStep.props.title,
			},
			{
				type: 'group',
				key: 'voice group',
				tooltip: TooltipKeys.UIVoice,
				title: rawProperties.Voice.props.title,
				subcomponent: null,
				children: [
					{
						...rawProperties.Voice.props.properties.Voice,
						key: 'Voice',
						subcomponent: rawProperties.Voice.props.subcomponent,
						title: "",
					}
				]
			},
		]
		return <UIEditorComponentRenderer
			{...props}
			properties={flatProperties}
		/>;
	}

	return (
		props.context === 'editor' ? 
			<>
				{repackProperties()}
			</>
			:
			<>
				<UIInsets size={4} {...props} />
				<UIHeaders size={4} anchor={'bottom'} align={'left'} {...props} />
				<UITextDescription {...props} />
				<UINextStep {...props} />
				<UIPreviousStep {...props} />
				<UIVoice {...props} />
			</>
	);
}